// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"green1": "#1da546",
	"blue1": "#14177c",
	"yellow": "#f4cb1c",
	"dark": "#333",
	"neutral": "#fff",
	"neutral1": "#2c3a4b",
	"neutral2": "#b4b4b4",
	"grey1": "#545d69",
	"footer": "#fcfcfa",
	"primary": "#f4cb1c",
	"secondary": "#b4b4b4",
	"error": "#ff5252",
	"accent": "#82b1ff",
	"info": "#2196f3",
	"success": "#4caf50",
	"warning": "#ffc107"
};
export default ___CSS_LOADER_EXPORT___;
